export default __webpack_public_path__ + "static/media/grafema_f1rst_03.96622031.jpg";